import { render } from "./HeaderPopup.vue?vue&type=template&id=d1960ab4&scoped=true"
import script from "./HeaderPopup.vue?vue&type=script&lang=js"
export * from "./HeaderPopup.vue?vue&type=script&lang=js"

import "./HeaderPopup.vue?vue&type=style&index=0&id=d1960ab4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1960ab4"]])

export default __exports__